import React from 'react';
import DateAndTime from '../micro/DateTime';

const PaymentTab = ({
  state,
  handleChange,
  showCheckout,
}) => (
  <div>
    <input className="input" type="text" 
      name="order"
      placeholder="Order Name"
      onChange={handleChange}/>
    <div className="columns">
      <div className="column">
        <label className="label">
          {/* Send Date */}
          <DateAndTime className="input" 
            placeholder="Send Date/Time"
            name="sendDate"
            value={state.sendDate}
            handleChange={handleChange} />
        </label>
      </div>
      <div className="column">
        <label className="label">
          {/* Event Date */}
          <DateAndTime className="input" 
            placeholder="Event Date/Time"
            name="eventDate"
            value={state.eventDate}
            handleChange={handleChange} />
        </label>
      </div>
    </div>
    <button className="button checkout__button" 
      onClick={showCheckout}>
      { state.checkout ? 'Edit Order' : 'Proceed To Checkout' }
    </button>
  </div>
)

export default PaymentTab


// WEBPACK FOOTER //
// ./src/components/campaigns/PaymentTab.js